<footer class="site-footer w-full border-t border-slate-200 bg-white">
  <div class="site-footer-inner flex w-full flex-col sm:flex-row items-center justify-between gap-4 px-4 sm:px-6 md:px-10 lg:px-12">
    <div class="site-footer-brand flex flex-wrap items-center gap-3 sm:gap-4">
      <a [href]="marketingSiteUrl" target="_blank" rel="noreferrer" class="site-footer-logo flex shrink-0 items-center transition-transform hover:scale-105">
        <img
          src="assets/brand/sahkaarx-logo.png"
          alt="SahkaarX"
          class="h-7 md:h-8 w-auto object-contain"
          onerror="this.src='https://sahkaarx.com/assets/images/sahkaarx-logo.png'"
        />
      </a>
      <span class="site-footer-copy text-xs sm:text-sm font-medium text-slate-500">&copy; {{ year }} SahkaarX</span>
    </div>

    <nav class="site-footer-links flex flex-wrap items-center justify-center gap-x-5 gap-y-2 text-xs sm:text-sm font-medium text-slate-600">
      <a class="transition-colors hover:text-[#0a4a23]" [href]="marketingSiteUrl + '/about-us'" target="_blank" rel="noreferrer">About</a>
      <a class="transition-colors hover:text-[#0a4a23]" href="https://www.ttpl.ind.in/contact" target="_blank" rel="noreferrer">Contact</a>
      <a class="transition-colors hover:text-[#0a4a23]" [href]="marketingSiteUrl + '/privacy-policy'" target="_blank" rel="noreferrer">Privacy</a>
      <a class="transition-colors hover:text-[#0a4a23]" [href]="marketingSiteUrl + '/terms-of-use'" target="_blank" rel="noreferrer">Terms</a>
      <a class="transition-colors hover:text-[#0a4a23]" [href]="marketingSiteUrl + '/refund-policy'" target="_blank" rel="noreferrer">Refund</a>
      <a class="transition-colors hover:text-[#0a4a23]" [href]="marketingSiteUrl + '/ai-usage-policy'" target="_blank" rel="noreferrer">AI Policy</a>
    </nav>

    <div class="site-footer-social flex shrink-0 items-center gap-2">
      <a
        class="flex h-8 w-8 items-center justify-center rounded-full border border-slate-300 text-slate-600 transition-all hover:border-[#0a4a23] hover:text-[#0a4a23] hover:bg-emerald-50"
        href="https://www.ttpl.ind.in/"
        target="_blank"
        rel="noreferrer"
        aria-label="TTPL website"
      >
        <span class="material-symbols-outlined text-[18px]">public</span>
      </a>
      <a
        class="flex h-8 w-8 items-center justify-center rounded-full border border-slate-300 text-slate-600 transition-all hover:border-[#0a4a23] hover:text-[#0a4a23] hover:bg-emerald-50"
        href="mailto:info@ttpl.ind.in"
        aria-label="Email"
      >
        <span class="material-symbols-outlined text-[18px]">mail</span>
      </a>
    </div>
  </div>
</footer>

